import { useCallback, useRef, useState } from "react";

/**
 * The button's disabled flag applies on the next render. This lock is taken
 * on the first click, so a second click cannot start another request while
 * the first one is still loading.
 */
export function useExclusiveSubmit() {
  const locked = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const begin = useCallback(() => {
    if (locked.current) return false;
    locked.current = true;
    setIsSubmitting(true);
    return true;
  }, []);

  const end = useCallback(() => {
    locked.current = false;
    setIsSubmitting(false);
  }, []);

  return { isSubmitting, begin, end };
}
